/**
 * Firebase Configuration Constants
 * Centralized collection and subcollection names to avoid magic strings
 * SECURITY: Using constants prevents typos and makes refactoring safer
 */

export const FIREBASE_COLLECTIONS = {
  BUILDINGS: "BuildingsX",
  ADHOC_SITES: "adhocSites",
  USERS: "UsersX",
};

export const FIREBASE_SUBCOLLECTIONS = {
  PRIVATE_DATA: "private_data",
  CURRENT_YEAR: "currentYear",
  DROPS: "drops",
  FORMS: "windowCleaningForms",
};

export const FORM_TYPES = {
  WEATHER: "Weather Report",
  EQUIPMENT: "Access Equipment",
  DEFECTS: "Defect Report",
  PPE: "PPE Form",
  SCHEDULED_TASKS: "Scheduled Tasks",
};

export const FORM_ACCESS_TYPES = {
  PRE: "pre",
  POST: "post",
};

export const CLEAN_STATUS = {
  CLEANED: "Cleaned",
  PENDING: "Pending",
};
